import Address from 'app/shared/models/Address';
import assign from 'lodash/assign';
import constants from '../constants';

const initState = () => new Address();

const address = (state = initState(), action = {}) => {
    const { type, payload } = action;

    if (type === constants.SET_ADDRESS) {
        return assign({}, state, payload);
    }
    return state;
};

export default address;
